import { Container } from "@mui/system";
import React, { useState, useEffect } from "react";
import AppStackLayout from "component/AppStackLayout/AppStackLayout";
import styles from "./Applications.module.css";
import { LinearProgress, Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import {
  useApplicationPayment,
  useGetCreditCheck,
  useMortgageApplication,
} from "api/mutations/applications/Application";
import Application from "component/Modules/application/Application";
import EmptyState from "component/emptyState/EmptyState";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";
import { useGetApplications } from "api/queries/dashboard/applications/Applications";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import { useNavigate } from "react-router";
import ApplyMortgage from "./modal/applyMortgage/ApplyMortgage";
import PaymentPrompt from "./modal/paymentPrompt/PaymentPrompt";
import Feedback from "component/feedback/Feedback";

function Applications() {
  const navigate = useNavigate();
  const {
    appFeedback,
    setAppFeedback,
    severity,
    message,
    openToast,
    setOpenToast,
    duration,
    submit,
    loading,
    openModal: openApplicationForm,
    setOpenModal: setOpenApplicationForm,
  } = useMortgageApplication();
  const { data: applications, loading: isLoadingApplications } =
    useGetApplications();
  const { checkCredit, feedbackState, screen, setScreen, loadingCreditCheck } =
    useGetCreditCheck();
  const {
    paymentFeedback,
    setPaymentFeedback,
    handlePayment,
    handlePaymentZest,
    openModal: openPaymentPrompt,
    setOpenModal: setOpenPaymentPrompt,
    severity2,
    message2,
    openToast2,
    setOpenToast2,
    duration2,
    setApplication,
  } = useApplicationPayment();

  const [selectedApplication, setSelectedApplication] = useState({});
  const [formState, setFormState] = useState(false);
  const [saveAndQuit, setSaveAndQuit] = useState(true);

  const handleCompleteApplication = (application) => {
    setFormState("continuation");
    setSelectedApplication(application);
    setScreen("form");
    setOpenApplicationForm(true);
  };

  const handleCloseBothFeedbackAndForm = () => {
    setOpenApplicationForm(false);
    setAppFeedback({});
  };

  return (
    <AppStackLayout activeLink="applications">
      <div className={styles.applications}>
        <Container maxWidth="xl">
          {isLoadingApplications ? (
            <LinearProgress />
          ) : (
            <div className={styles.applications_content}>
              <div className={styles.heading}>
                <Typography>Submitted Applications</Typography>

                {applications?.data?.data?.some((application) => {
                  return application.status === "pending";
                })
                  ? null
                  : applications?.data?.data?.length > 0 && (                      <div className={styles.btn}>
                        <AppButton
                          width={"217px"}
                          handleAction={() => {
                            setFormState("start");
                            setScreen("credit-check");
                            setOpenApplicationForm(true);
                          }}
                          textColor="#FFFFFF"
                          btnBg="#0072CE"
                          btnText="Apply for Mortgage"
                        />
                      </div>
                    )}
              </div>

              {applications?.data?.data.length > 0 ? (
                <div className={styles.body}>
                  {applications?.data?.data?.map((application) => {
                    return (
                      <Application
                        handleMakePayment={(application) => {
                          setApplication(application);
                          setSelectedApplication(application);
                          setOpenPaymentPrompt(true);
                        }}
                        handleCompleteApplication={handleCompleteApplication}
                        key={application.id}
                        application={application}
                      />
                    );
                  })}
                </div>
              ) : (
                <EmptyState
                  btnText="Apply for Mortgage"
                  text="You currently do not have any active applications nor pending
               applications, click the button below to make an application."
                  handleClickButton={() => {
                    setScreen("credit-check");
                    setFormState("start");
                    setOpenApplicationForm(true);
                  }}
                />
              )}
            </div>
          )}
        </Container>
        <TTFSnackbar
          severity={severity}
          message={message}
          open={openToast}
          setOpen={setOpenToast}
          duration={duration}
        />
        <TTFSnackbar
          severity={severity2}
          message={message2}
          open={openToast2}
          setOpen={setOpenToast2}
          duration={duration2}
        />
        {openApplicationForm && (
          <AppBackdrop
            openModal={openApplicationForm}
            children={
              <ApplyMortgage
                saveAndQuit={saveAndQuit}
                setSaveAndQuit={setSaveAndQuit}
                application={selectedApplication}
                formState={formState}
                checkCredit={checkCredit}
                screen={screen}
                setScreen={setScreen}
                loadingCreditCheck={loadingCreditCheck}
                feedbackState={feedbackState}
                loading={loading}
                submit={submit}
                setOpenApplicationForm={setOpenApplicationForm}
              />
            }
          />
        )}
        {openPaymentPrompt && (
          <AppBackdrop
            openModal={openPaymentPrompt}
            children={
              <PaymentPrompt
                selectedApplication={selectedApplication}
                handlePayment={() => {
                  handlePayment(selectedApplication);
                }}
                handlePaymentZest={() => {
                  handlePaymentZest(selectedApplication);

                }}
                setOpenPaymentPrompt={setOpenPaymentPrompt}
              />
            }
          />
        )}
        {paymentFeedback.open && (
          <AppBackdrop
            openModal={paymentFeedback.open}
            handleCloseModal={() => {
              setPaymentFeedback({});
            }}
            children={
              <Feedback
                btnText={"Close"}
                secondaryText={paymentFeedback.message}
                feedbackState={paymentFeedback.status}
                handleClickBtn={() => {
                  setPaymentFeedback({});
                }}
              />
            }
          />
        )}
        {appFeedback.open && (
          <AppBackdrop
            openModal={appFeedback.open}
            handleCloseModal={() => {
              //setAppFeedback({});
              //setOpenApplicationForm(false);
            }}
            children={
              <Feedback
                btnText={
                  saveAndQuit
                    ? "Close"
                    : appFeedback.status === "success"
                    ? "Proceed to Documents"
                    : "Close"
                }
                secondaryText={appFeedback.message}
                feedbackState={appFeedback.status}
                handleClickBtn={() => {
                  saveAndQuit
                    ? handleCloseBothFeedbackAndForm()
                    : appFeedback.status === "success"
                    ? navigate("/documents")
                    : setAppFeedback({});
                }}
              />
            }
          />
        )}
      </div>
    </AppStackLayout>
  );
}

export default Applications;
